
export const isObjectEqual = (object1: any, object2: any): boolean =>
  JSON.stringify(object1) === JSON.stringify(object2);